import * as T from "@shared/types";
import { axios } from ".";

const CONNECTIONS_BASE_URL = "/api/v1/connections/bc-connections";

export const getConnectionById = async (connectionId: string) => {
  const url = `${CONNECTIONS_BASE_URL}/${connectionId}`;
  const response = await axios.get<{ data: T.Connection }>(url);
  return response.data.data;
};

export const getConnections = async (params: T.ConnectionQueryParams) => {
  const response = await axios.get<{ data: T.Connection[] }>(CONNECTIONS_BASE_URL, { params });
  return response.data.data;
};

export const getInstallationConnections = async (installationId: string, type?: T.Connection["type"]) => {
  const config = { params: { type } };
  const url = `${CONNECTIONS_BASE_URL}/installations/${installationId}`;
  const response = await axios.get<{ data: T.Connection[] }>(url, config);
  return response.data.data;
};

export const getInstallationProductConnections = async (installationId: string) => {
  const type: T.Connection["type"] = "productConnection";
  const config = { params: { type } };
  const url = `${CONNECTIONS_BASE_URL}/installations/${installationId}`;
  const response = await axios.get<{ data: T.ProductConnection[] }>(url, config);
  return response.data.data;
};
